import React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import { compose } from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import waitFor from 'js/lib/waitFor';

import { loadThreads } from 'bundles/discussions/actions/ThreadsActions';
import ControlsBar from 'bundles/discussions/components/ControlsBar';
import ListBody from 'bundles/discussions/components/ListBody';
import { NewThreadButtonNaptimeContainer as NewThreadButton } from 'bundles/discussions/components/NewThreadButton';
import ThreadsListEntry from 'bundles/discussions/components/discussionsBody/ThreadsListEntry';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import { loadingStates } from 'bundles/discussions/constants';
import * as discussionsUrl from 'bundles/discussions/utils/discussionsUrl';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';
import unreadTracker from 'bundles/discussions/utils/unreadTracker';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';
import PaginationControls from 'bundles/page/components/PaginationControls';

import _t from 'i18n!nls/discussions';

import 'css!bundles/discussions/components/discussionsBody/__styles__/ThreadsList';
import 'css!bundles/page/components/__styles__/PaginationControls';

class ThreadsList extends React.Component {
  static propTypes = {
    courseForums: PropTypes.arrayOf(PropTypes.instanceOf(OnDemandCourseForumsV1)),
    mentorForums: PropTypes.arrayOf(PropTypes.instanceOf(OnDemandMentorForumsV1)),
    groupForums: PropTypes.arrayOf(PropTypes.instanceOf(GroupForumsV1)),
    currentForumId: PropTypes.string,
    currentForum: PropTypes.oneOfType([
      PropTypes.instanceOf(OnDemandCourseForumsV1),
      PropTypes.instanceOf(OnDemandMentorForumsV1),
      PropTypes.instanceOf(GroupForumsV1),
    ]),
    sort: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    entries: PropTypes.array,
    loadingState: PropTypes.oneOf(Object.keys(loadingStates)),
    pageCount: PropTypes.number,
    activeFilterQueryString: PropTypes.string,
    userId: PropTypes.number,
    hasModerationRole: PropTypes.bool,
    currentForumUrl: PropTypes.string,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof ThreadsList.contextTypes>;

  state = {
    inSearch: false,
  };

  componentWillMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { sort, page, currentForum, activeFilterQueryString } = this.props;

    this.context.executeAction(loadThreads, {
      filterQueryString: activeFilterQueryString,
      sort,
      pageNum: page,
      forumType: currentForum && currentForum.forumType.typeName,
      forumId: currentForum && currentForum.id,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type 'Readonly... Remove this comment to see the full error message
      userId: this.props.userId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
      includeDeleted: this.props.hasModerationRole,
    });
  }

  componentWillUpdate(nextProps: $TSFixMe, nextState: $TSFixMe, nextContext: $TSFixMe) {
    if (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.sort !== nextProps.sort ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.page !== nextProps.page ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForumId' does not exist on type '... Remove this comment to see the full error message
      this.props.currentForumId !== nextProps.currentForumId ||
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'activeFilterQueryString' does not exist ... Remove this comment to see the full error message
      this.props.activeFilterQueryString !== nextProps.activeFilterQueryString
    ) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentForum' does not exist on type 'Re... Remove this comment to see the full error message
      const { currentForum } = this.props;
      this.context.executeAction(loadThreads, {
        filterQueryString: nextProps.activeFilterQueryString,
        sort: nextProps.sort,
        pageNum: nextProps.page,
        forumType: currentForum && currentForum.forumType.typeName,
        forumId: currentForum && currentForum.id,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type 'Readonly... Remove this comment to see the full error message
        userId: this.props.userId,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
        includeDeleted: this.props.hasModerationRole,
      });
    }
  }

  onPageChange = (page: $TSFixMe) => {
    const { router } = this.context;
    router.push({
      pathname: this.context.router.location.pathname,
      params: {},
      query: Object.assign(this.context.router.location.query, { page }),
    });
  };

  toggleSearch = () => {
    this.setState({
      inSearch: !this.state.inSearch,
    });
  };

  renderEntry = (entry: $TSFixMe) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'activeFilterQueryString' does not exist ... Remove this comment to see the full error message
    const { activeFilterQueryString, courseForums, mentorForums, groupForums, currentForum, currentForumUrl } =
      this.props;

    const isAnswered = entry.lastAnsweredAt && entry.lastAnsweredBy;
    const isRead = !unreadTracker.hasUnread(entry);
    const profile = isAnswered ? entry.lastAnsweredBy : entry.creator;
    const metadataLabel = isAnswered ? _t('Last post by') : _t('Created by');
    const forums = courseForums.concat(mentorForums).concat(groupForums);
    const forumForEntry = forums.find((forum: $TSFixMe) => forum.forumId === entry.forumId);
    const forumName = (forumForEntry && currentForum.id !== forumForEntry.id && forumForEntry.title) || undefined;
    const discussionsLink = discussionsUrl.getDeepLink(currentForumUrl, entry);
    const hasAnswerCount = typeof entry.answerCount !== 'undefined' && !isNaN(entry.answerCount);
    const answerCount = hasAnswerCount ? entry.answerCount : entry.totalAnswerCount;

    return (
      <ThreadsListEntry
        key={entry.id + activeFilterQueryString}
        threadUrl={discussionsLink}
        profile={profile}
        timestamp={entry.lastAnsweredAt || entry.createdAt}
        threadName={entry.content.question}
        questionId={entry.id}
        questionUserId={entry.creatorId}
        entry={entry}
        isPinned={!!(entry.state && entry.state.pinned)}
        isDeleted={!!(entry.state && entry.state.deleted)}
        isRead={isRead}
        forumName={forumName}
        metadataLabel={metadataLabel}
        viewCount={Math.max(answerCount, entry.viewCount)}
        answerCount={answerCount}
        badge={entry.answerBadge.answerBadge}
      />
    );
  };

  render() {
    const inAllDiscussions = this.context.router.isActive({
      pathname: discussionsUrl.getAllThreadsDiscussionsUrl(),
    });

    return (
      <div className="rc-ThreadsList styleguide horizontal-box">
        <div className="flex-2">
          <div className="card-rich-interaction">
            <ControlsBar
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type 'Readonly<{... Remove this comment to see the full error message
              sort={this.props.sort}
              inSearch={this.state.inSearch}
              toggleSearch={this.toggleSearch}
              showSearchBox={!inAllDiscussions}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type 'Re... Remove this comment to see the full error message
              loadingState={this.props.loadingState}
            />
            <ListBody
              emptyStatePlaceholderText={_t('No Posts Yet')}
              fossilized={this.state.inSearch}
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type 'Re... Remove this comment to see the full error message
              loadingState={this.props.loadingState}
            >
              {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'entries' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              {this.props.entries && this.props.entries.map(this.renderEntry)}
            </ListBody>
          </div>
          <PaginationControls
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onPageChange: (page: any) => void; pageCou... Remove this comment to see the full error message
            onPageChange={this.onPageChange}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'pageCount' does not exist on type 'Reado... Remove this comment to see the full error message
            pageCount={this.props.pageCount}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            currentPage={this.props.page}
            maxPages={5}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  connectToStores(
    ['SessionFilterStore', 'ThreadsStore', 'ApplicationStore'],
    ({ SessionFilterStore, ThreadsStore, ApplicationStore }) => ({
      activeFilterQueryString: SessionFilterStore.activeFilterQueryString,
      entries: ThreadsStore.getThreadsPage(),
      loadingState: ThreadsStore.getLoadingState(),
      pageCount: ThreadsStore.getPageCount(),
      userId: ApplicationStore.getUserData().id,
    })
  ),
  discussionsForumsHOC({
    fields: ['title', 'link', 'forumType'],
    subcomponents: [NewThreadButton],
  }),
  connectToRouter(routerConnectToCurrentForum),
  waitFor((props) => !!(props.activeFilterQueryString !== undefined && props.sort && props.page && props.currentForum))
)(ThreadsList);
